import axiosInstance from "../../axios/axios";

export const GetOtpApi = async (credential) =>
  await axiosInstance.post(`/api/westside/user/otp/get`, credential);

export const SendOtpApi = async (credential) =>
  await axiosInstance.post(`/api/westside/user/otp/send`, credential);
